export default "/assets/images/mila-air-specs-sm.webp?c03228ada8a9506e523bee454b63ebd6";